export const useLocalStorage = () => {
  const hasWindow = typeof window !== 'undefined';
  const setItem = (key: string, value: string) => {
    if (hasWindow) {
      localStorage.setItem(key, value);
    }
  };

  const getItem = (key: string) => {
    if (hasWindow) return localStorage.getItem(key);
  };

  const removeItem = (key: string) => {
    if (hasWindow) localStorage.removeItem(key);
  };

  return {
    setItem,
    getItem,
    removeItem,
  };
};
